module.exports = __webpack_public_path__ + "static/media/et.512bde19.svg";